<template>
  <div
    v-if="isVisible"
    data-testid="main-modal"
    :class="[
      'fixed inset-0 w-screen h-screen flex justify-center items-center z-50 bg-[rgba(61,59,59,0.4)]',
    ]"
  >
    <div
      data-testid="modal-qrcode"
      :class="[
        'min-w-[400px] w-[548px] min-h-[424px] text-center flex flex-col items-center shadow-[0px_8px_16px_rgba(44,38,38,0.16)] rounded-[24px] bg-white',
      ]"
    >
      <div
        :class="[
          'flex items-center justify-between w-full rounded-[24px_24px_0px_0px] bg-[linear-gradient(180deg,_#ffee99,_#fff)]',
        ]"
      >
        <div class="flex items-center justify-between w-full">
          <div
            class="flex items-center ml-[24px] mt-[24px] mr-[auto] mb-[24px]"
          >
            <img
              class="w-[48px] h-[48px] mr-[16px] align-top rounded-[8px]"
              src="../assets/images/go_logo.png"
              alt="download icon"
            />
            <div class="text-left space-y-1">
              <p class="text-lg font-bold mb-[4px] text-[#292828]">
                GO by Krungsri Auto ดาวน์โหลดเลย
              </p>
              <p class="text-sm font-medium text-[#292828]">
                แอปพลิเคชันเพื่อไลฟ์สไตล์ผู้ใช้รถ
              </p>
            </div>
          </div>

          <div class="flex self-start mt-[24px]">
            <button class="self-start">
              <img
                data-testid="menu-icon"
                :src="closeButton"
                alt="Menu Icon"
                class="mr-[24px] w-[32px] h-[32px]"
                @mouseover="getCloseiconHover"
                @mousedown="getCloseiconHover"
                @mouseleave="getCloseicon"
                @click.self="hide"
              />
            </button>
          </div>
        </div>
      </div>
      <img
        data-testid="qrcode-img"
        :src="qrCodeImage"
        alt="QR Code"
        class="w-[200px] h-[200px] mt-[32px] mb-[32px]"
      />

      <p class="text-sm font-medium mb-[32px] text-[#292828]">
        รองรับทั้ง iOS และ Android
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import closeIcon from "@/assets/images/close_button.png";
import closeIconPressed from "@/assets/images/close_button_pressed.png";
import qrCodeImg from "@/assets/images/modal_qr_code.png";

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },

  emits: ["close"],
  data() {
    return {
      qrCodeImage: qrCodeImg,
      closeButton: closeIcon,
    };
  },
  mounted() {
    this.getCloseicon();
  },
  beforeUnmount() {
    this.getCloseicon();
  },
  methods: {
    getCloseicon() {
      this.closeButton = closeIcon;
    },
    getCloseiconHover() {
      this.closeButton = closeIconPressed;
    },
    hide() {
      this.getCloseicon();
      this.$emit("close");
    },
  },
};
</script>
